import React from "react";
import ResponsiveAppBar from "../component/Navbar/Navbar";
import Header from "../component/Header/Header";
import ItemList from "../component/ItemList/itemList";

const Home = () => {
  return (
    <div>
      <ResponsiveAppBar/>
      <Header/>
      <ItemList/>
    </div>
  );
};

export default Home;
